import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const FormContainer = styled(motion.div)`
    background-color: rgba(255, 255, 255, 0.9);
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
    margin-bottom: 60px;
    width: 80%;
    max-width: 500px;
    backdrop-filter: blur(5px);
`;

const Input = styled.input`
    width: 100%;
    padding: 15px;
    margin-bottom: 25px;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-sizing: border-box;
    font-size: 1.1em;
`;

const TextArea = styled.textarea`
    width: 100%;
    padding: 15px;
    margin-bottom: 25px;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-sizing: border-box;
    resize: vertical;
    min-height: 120px;
    font-size: 1.1em;
`;

const Button = styled(motion.button)`
    background-color: ${(props) => props.theme.primaryColor};
    color: white;
    padding: 15px 25px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1.2em;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: #d81b60;
    }
`;

function WishForm({ onWishSubmit }) {
    const [name, setName] = useState('');
    const [message, setMessage] = useState('');
    const yourWhatsAppNumber = '919370755331';

    const handleSubmit = (event) => {
        event.preventDefault();
        if (name.trim() && message.trim()) {
            const whatsappMessage = encodeURIComponent(`New Birthday Wish!\nFrom: ${name}\nMessage: ${message}`);
            const whatsappURL = `https://wa.me/${yourWhatsAppNumber}?text=${whatsappMessage}`;
            window.open(whatsappURL, '_blank');

            onWishSubmit(name, message);
            setName('');
            setMessage('');
        }
    };

    return (
        <FormContainer
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4, ease: 'easeInOut' }}
        >
            <h2>Send Your Loving Wish</h2>
            <form onSubmit={handleSubmit}>
                <Input
                    type="text"
                    placeholder="Your Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />
                <TextArea
                    placeholder="Your Heartfelt Message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                />
                <Button
                    type="submit"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    Send with Love
                </Button>
            </form>
        </FormContainer>
    );
}

export default WishForm;